// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  min-height: 100%;
  margin: 0;
}

body,
body * {
  font-family: "Roboto", serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  font-variation-settings: "wdth" 100;
  box-sizing: border-box;
}

body {
  background-color: #FAFAFA;
  background-image: linear-gradient(120deg, #fdfbfb, #ebedee) !important;
}

#webpack-dev-server-client-overlay {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAEA;;EAEE,gBAAA;EACA,SAAA;AAAF;;AAGA;;EAEE,4BAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mCAAA;EACA,sBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,sEAAA;AAAF;;AAGA;EACE,aAAA;AAAF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap');\r\n\r\nhtml,\r\nbody {\r\n  min-height: 100%;\r\n  margin: 0;\r\n}\r\n\r\nbody,\r\nbody * {\r\n  font-family: \"Roboto\", serif;\r\n  font-optical-sizing: auto;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n  font-variation-settings: \"wdth\" 100;\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  background-color: #FAFAFA;\r\n  background-image: linear-gradient(120deg, #fdfbfb, #ebedee) !important;\r\n}\r\n\r\n#webpack-dev-server-client-overlay {\r\n  display: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
